/*
* 連打防止など共通処理用のjs
* 実行処理のみ書いてロジックは書かないこと
*/

var $        = require("jquery"),
    _        = require("underscore"),
    header   = require("./_layout/header"),
    tips     = require("./_require/tips"),
    info     = require("./_require/info"),
    csrfTokenSupporter = require("./_require/csrf_token_supporter"),
    barragePrevention  = require("./_require/barrage_prevention"),
    svg4everybody      = require("svg4everybody");

$(document).ready(function () {
    // 連打防止
    barragePrevention.run();
    //csrfトークンをformに追加する処理
    csrfTokenSupporter.setFormCsrfToken();

    //ヘッダーメニューの制御処理
    header.menu();

    // infoチップスを出すための制御処理
    info.run();

    /*サイト全体のtips表示を制御するための暫定メソッド
    * TODO: サイトの速度が改善され次第、ローディングtipsの処理は削除 テンプレート側の非表示フラグも忘れず消す
    */
    _commonTipsController();

    /*
    * スクロール時についてくるナビの共通処理
    * TODO: あるべき場所に移動
    */
    $(".js-scroll-global-nav").scrollNavController({
        "scroll"   : function(){ $(this).css('position','fixed'); },
        "noScroll" : function(){ $(this).css('position','absolute'); }
    });


    $(".js-scroll-project-nav").scrollNavController({
        "scroll"   : function(){ $(this).addClass("is-scroll"); },
        "noScroll" : function(){ $(this).removeClass("is-scroll"); }
    });

    // IEでsvgスプライトを利用するためのpolyfill
    svg4everybody();
});

function _commonTipsController() {
    /*
    * 保存処理後の成功メッセージ処理
    * if (formから更新した場合の表示判定 || ajaxから更新した場合の表示判定)
    */
    if ($(".js-show-success-message").length || sessionStorage.getItem('showSuccessTipsFlg') === "true"){
        var displayTime = 6000;
        var messageText = "保存しました。";
        if ($(".js-show-success-message-text").val()){
          messageText = $(".js-show-success-message-text").val();
        }
        tips.headerTipsMessageLongRender(messageText, "hide", displayTime);
        //ページローディング判定の邪魔になるのでメッセージ表示後はフラグを消す
        window.setTimeout(function(){
            $(".js-show-success-message").remove();
        }, displayTime+1000);

        sessionStorage.setItem('showSuccessTipsFlg', false);
        //保存メッセージが表示された場合読み込みメッセージが表示されることはないためここでfalseを入れる
        sessionStorage.setItem('tipsDisplayedFlg', false);
    }

    /*
    * 下記のページ遷移時の処理は
    * ローディングが非常に遅いために暫定的に入れている処理
    *
    * ローディングをしなくて良いページ用の処理
    * <input type="hidden" class="js-hide-loading" value="true">
    * 上記を置いておくとローディングチップスがでない
    * TODO: 上記の記述がないページからあるページに行く場合は遷移が早いにもかかわらずローディングが出てしまう
    * そもそもこれ自体暫定対応なので一旦これで。
    */
    //ページ移動時にローディングを出す
    $(window).on('beforeunload', function() {
        if ($(".js-hide-loading").length || $(".js-show-success-message").length) {
           return;
        }
        //ブラウザバック対策。　ブラウザバックするとキャッシュが効いて下記の読み込み
        //処理が実行される前にページ移動してしまう。　それを利用して50msより早い速度で
        //ページ移動された場合はtipsDisplayedFlgが立たず、読み込み完了表示がでないようにした。
        window.setTimeout(function(){
            sessionStorage.setItem('tipsDisplayedFlg', true);
        }, 50);
        tips.headerTipsMessageRender("読み込んでいます","hide", 100000, { "loadingTips": true });
    });

    if (
        $(".js-hide-loading").length ||
        $(".js-show-success-message").length ||
        sessionStorage.getItem('tipsDisplayedFlg') === "false"
    ) {
        return;
    }
    //ページ遷移後のローディング後の完了通知
    //tips.headerTipsMessageRender("読み込みました..","show", 500);
    sessionStorage.setItem('tipsDisplayedFlg', false);
}
